import { Fragment } from 'react';
import { clsx } from 'clsx';
import Icon from 'components/common/Icon';

interface StepperProps {
  stepTitles: string[];
  activeStep: string;
  onClick: (index: number) => void;
}

const Stepper = ({ stepTitles, activeStep, onClick }: StepperProps) => {
  const activeIndex = stepTitles.indexOf(activeStep);

  return (
    <div className="flex w-full items-start">
      {stepTitles.map((title, index) => {
        const isCompleted = index < activeIndex;
        const isActive = index === activeIndex;
        const isClickable = isCompleted || isActive;

        return (
          <Fragment key={title}>
            <button
              className={clsx(
                'flex flex-col items-center gap-2',
                isClickable ? 'cursor-pointer' : 'cursor-default',
              )}
              disabled={!isClickable}
              onClick={() => onClick(index)}
              type="button"
            >
              <div
                className={clsx(
                  'flex h-10 w-10 items-center justify-center rounded-full border text-lg font-semibold',
                  isCompleted &&
                    'border-[#C5DEDD] border-2 bg-[#E8F2F1] text-primary-d-700',
                  isActive &&
                    'border-primary-d-700 bg-primary-d-700 text-white',
                  !isCompleted &&
                    !isActive &&
                    'border-gray-d-300 bg-white text-gray-d-400',
                )}
              >
                {isCompleted ? (
                  <div className="h-5 w-5">
                    <Icon id="check" />
                  </div>
                ) : (
                  index + 1
                )}
              </div>
              <span
                className={clsx(
                  'text-sm',
                  isCompleted && 'font-medium text-[#6B9C98]',
                  isActive && 'font-semibold text-gray-d-900',
                  !isCompleted && !isActive && 'text-gray-d-400',
                )}
              >
                {title}
              </span>
            </button>
            {index < stepTitles.length - 1 && (
              <div
                className={clsx(
                  'mt-5 h-0.5 flex-1',
                  isCompleted ? 'bg-[#C5DEDD]' : 'bg-gray-d-200',
                )}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;
